import React from 'react';
import { Box } from '@mui/material';
import type { ReactNode } from 'react';
import { Header } from './Header';
import { BottomNav, BOTTOM_NAV_OFFSET } from './BottomNav';
import { PageBreadcrumbs } from './PageBreadcrumbs';

interface AppLayoutProps {
  children: ReactNode;
  /** Формы и ведение матча: на mobile без шапки и нижней панели (у страницы своя панель с «✕»). */
  bare?: boolean;
}

export const AppLayout: React.FC<AppLayoutProps> = ({ children, bare = false }) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', width: '100%' }}>
    <Box sx={{ display: bare ? { xs: 'none', lg: 'block' } : 'block', position: 'sticky', top: 0, zIndex: 1100 }}>
      <Header />
    </Box>
    <Box
      component="main"
      sx={{
        flex: 1,
        width: '100%',
        bgcolor: 'background.default',
        pb: bare
          ? 0
          : {
              xs: `calc(${BOTTOM_NAV_OFFSET} + 16px)`,
              lg: 0,
            },
      }}
    >
      <Box className="cont">
        {!bare && <PageBreadcrumbs />}
        {children}
      </Box>
    </Box>
    {!bare && <BottomNav />}
  </Box>
);
